import React from 'react';

function EgyebHajos() {
  return (
    <h1>Egyéb hajós programjaink</h1>
  );
}

export default EgyebHajos;
